import React from "react";
import PropTypes from 'prop-types';
import Banner from './elements/Banner';
import MessageBanner from './elements/banner/MessageBanner';
import LinkButton from './elements/form/button/LinkButton';

export default class VerificationPopup extends React.PureComponent {
    state = {
        isClosed: false,
    };

    resendVerificationEmailHandler = () => {
        const { showVerificationModal } = this.props;

        return showVerificationModal();
    };

    notificationClosed = () => {
        let { resetEmailVerification } = this.props;

        return resetEmailVerification();
    };
    render() {
        let {
            isLogged,
            isVerified,
            isResendVerificationSuccess,
            isPageLoading,
            isVerificationPopupFocused,
        } = this.props;

        let { isClosed } = this.state;

        if (!isLogged || isVerified || isPageLoading) {
            return false;
        }

        const animationClass = isVerificationPopupFocused ? 'wiggle' : '';
        const containerClass = 'verification-info' + (isClosed ? ' closed' : ' opened');

        return (
            <div className={containerClass}>
                {isResendVerificationSuccess ? <MessageBanner
                    className={`${animationClass} verification-message-popup`}
                    onCloseCallback={this.notificationClosed}
                    isNoAutoClose={true}
                >Verification email was sent <span role={'img'} aria-label={'peace'}>✌️</span></MessageBanner> : <Banner
                    isOpen={true}
                    isNoAutoClose={true}
                    className={`verification-popup ${animationClass}`}
                    button={
                        <div className={'button-text'}>
                            No email received after more than 30 minutes?&nbsp;
                            <LinkButton isLoading={false} onClick={this.resendVerificationEmailHandler} className={''}>Resend mail</LinkButton>
                        </div>}>
                    <div className={'inner'}><span role={'img'} aria-label={'mail'}>✉️</span> We've sent you an email to verify your email address. This is mandatory to be able to log in with the desktop app.</div>
                </Banner>}
            </div>
        );
    }
}

VerificationPopup.propTypes = {
    isLogged: PropTypes.bool.isRequired,
    isVerified: PropTypes.bool,
    isResendVerificationPending: PropTypes.bool.isRequired,
    isResendVerificationeError: PropTypes.bool.isRequired,
    isResendVerificationSuccess: PropTypes.bool.isRequired,
    isPageLoading: PropTypes.bool.isRequired,
    isVerificationPopupFocused: PropTypes.bool.isRequired,
    type: PropTypes.string,
    resetEmailVerification: PropTypes.func.isRequired,
    resendEmailVerification: PropTypes.func.isRequired,
    showVerificationModal: PropTypes.func.isRequired,
};
